"use client";
import { useState, useEffect } from "react";
import { Spin, Empty } from "antd";
import { IoChevronDown } from "react-icons/io5";
import CourseService from "@/services/api/CourseService";
import HomePageService from "@/services/api/HomeService";
import CommonService from "@/services/api/CommonService";
import CourseCard from "@/components/common/card/CourseCard";
import SectionTitle from "@/components/common/section-title/SectionTitle";
import CommonImage from "@/components/common/image/CommonImage";
import ProgramCard from "@/components/common/card/ProgramCard";
import { useRouter } from "next/navigation";
import CoursePageCard from "./components/CoursePageCard";

export default function CourseAll() {
  const [loading, setLoading] = useState(false);
  const [programs, setPrograms] = useState([]);
  const [classes, setClasses] = useState([]);
  const [courses, setCourses] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [selectedProgram, setSelectedProgram] = useState(null);
  const [selectedClassId, setSelectedClassId] = useState(null);

  const router = useRouter();

  const fetchInitialData = async () => {
    try {
      const programsData = await HomePageService.getPrograms();
      const allCoursesProgram = {
        name: "সকল কোর্স",
        icon_url: "/images/home-page/all-courses.avif",
        slug: "all",
        id: null,
      };
      const updatedPrograms = [allCoursesProgram, ...(programsData || [])];
      setPrograms(updatedPrograms || []);
      setSelectedProgram(allCoursesProgram);

      const classData = await CommonService.getAllClasses();
      setClasses(classData || []);
    } catch (err) {
      console.error("Error loading initial programs/classes:", err);
    }
  };

  const fetchCourses = async (
    pageNum = 1,
    programSlug = null,
    classId = null
  ) => {
    try {
      setLoading(true);
      const response = await CourseService.getFilteredCourses({
        page: pageNum,
        program_slug: programSlug,
        class_id: classId,
      });

      const resData = response.courses;
      const newCourses = resData.data || [];

      if (pageNum === 1) {
        setCourses(newCourses);
      } else {
        setCourses((prev) => [...prev, ...newCourses]);
      }

      if (!resData?.next_page_url || newCourses.length === 0) {
        setHasMore(false);
      }
    } catch (err) {
      console.error("Error loading courses:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleLoadMore = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    fetchCourses(nextPage, selectedProgram?.id, selectedClassId);
  };

  const handleProgramClick = (program) => {
    setSelectedProgram(program);
    setSelectedClassId(null);
    setPage(1);
    setHasMore(true);
    router.push(`/courses/${program.slug}`, undefined, { shallow: true });
    fetchCourses(1, program.slug, null);
  };

  const handleClassClick = (classId) => {
    setSelectedClassId(classId);
    setPage(1);
    setHasMore(true);
    fetchCourses(1, selectedProgram?.slug, classId);
  };

  useEffect(() => {
    fetchInitialData();
    fetchCourses(1);
  }, []);

  return (
    <CoursePageCard
      loading={loading}
      programs={programs}
      selectedProgram={selectedProgram}
      handleProgramClick={handleProgramClick}
      classes={classes}
      selectedClassId={selectedClassId}
      handleClassClick={handleClassClick}
      courses={courses}
      hasMore={hasMore}
      handleLoadMore={handleLoadMore}
    />
  );
}
